import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const styles = {
  container: {
    backgroundColor: 'white',
    borderRadius: '4px',
    padding: '15px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  },
  group: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px 0',
    borderBottom: '1px solid #f0f0f0'
  },
  label: {
    margin: 0,
    minWidth: '240px',
    fontSize: '13px',
    color: '#333'
  },
  input: {
    padding: '6px 10px',
    border: '1px solid #e5e7eb',
    borderRadius: '3px',
    backgroundColor: '#fff',
    fontSize: '12px',
  },
  inputsRow: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap'
  }
};

const initParams = {
  partWeight: { enabled: false, value: '' },
  partDimensions: { enabled: false, length: '', width: '', height: '', thickness: '' },
  numberOfRotation: { enabled: false, value: '' },
  colorDeviationDelta: { enabled: false, value: '' },
  balanceWithinBounce: { enabled: false, value: '' }
};

const InspectionParameters = ({ data, onChanges }) => {
  const [params, setParams] = useState({ ...initParams, ...(data || {}) });

  useEffect(() => {
    if (onChanges) onChanges(params);
  }, [params, onChanges]);

  const toggle = key => {
    setParams(prev => ({
      ...prev,
      [key]: { ...prev[key], enabled: !prev[key].enabled }
    }));
  };

  const setValue = (key, field, value) => {
    setParams(prev => ({
      ...prev,
      [key]: { ...prev[key], [field]: value }
    }));
  };

  return (
    <div style={styles.container}>
      <div style={styles.group}>
        <input
          id="param-part-weight"
          type="checkbox"
          checked={params.partWeight.enabled}
          onChange={() => toggle('partWeight')}
        />
        <label htmlFor="param-part-weight" style={styles.label}>Part Weight</label>
        {params.partWeight.enabled && (
          <input
            style={styles.input}
            placeholder="Enter part weight"
            value={params.partWeight.value}
            onChange={e => setValue('partWeight', 'value', e.target.value)}
          />
        )}
      </div>

      <div style={styles.group}>
        <input
          id="param-part-dimensions"
          type="checkbox"
          checked={params.partDimensions.enabled}
          onChange={() => toggle('partDimensions')}
        />
        <label htmlFor="param-part-dimensions" style={styles.label}>Part Dimensions</label>
        {params.partDimensions.enabled && (
          <div style={styles.inputsRow}>
            <input
              style={styles.input}
              placeholder="Length"
              value={params.partDimensions.length}
              onChange={e => setValue('partDimensions', 'length', e.target.value)}
            />
            <input
              style={styles.input}
              placeholder="Width"
              value={params.partDimensions.width}
              onChange={e => setValue('partDimensions', 'width', e.target.value)}
            />
            <input
              style={styles.input}
              placeholder="Height"
              value={params.partDimensions.height}
              onChange={e => setValue('partDimensions', 'height', e.target.value)}
            />
            <input
              style={styles.input}
              placeholder="Thickness"
              value={params.partDimensions.thickness}
              onChange={e => setValue('partDimensions', 'thickness', e.target.value)}
            />
          </div>
        )}
      </div>

      <div style={styles.group}>
        <input
          id="param-rotation"
          type="checkbox"
          checked={params.numberOfRotation.enabled}
          onChange={() => toggle('numberOfRotation')}
        />
        <label htmlFor="param-rotation" style={styles.label}>Number of Rotation</label>
        {params.numberOfRotation.enabled && (
          <input
            style={styles.input}
            placeholder="Enter rotations"
            value={params.numberOfRotation.value}
            onChange={e => setValue('numberOfRotation', 'value', e.target.value)}
          />
        )}
      </div>

      <div style={styles.group}>
        <input
          id="param-color-deviation"
          type="checkbox"
          checked={params.colorDeviationDelta.enabled}
          onChange={() => toggle('colorDeviationDelta')}
        />
        <label htmlFor="param-color-deviation" style={styles.label}>Color Deviation Delta</label>
        {params.colorDeviationDelta.enabled && (
          <input
            style={styles.input}
            placeholder="Enter delta"
            value={params.colorDeviationDelta.value}
            onChange={e => setValue('colorDeviationDelta', 'value', e.target.value)}
          />
        )}
      </div>

      <div style={styles.group}>
        <input
          id="param-balance-bounce"
          type="checkbox"
          checked={params.balanceWithinBounce.enabled}
          onChange={() => toggle('balanceWithinBounce')}
        />
        <label htmlFor="param-balance-bounce" style={styles.label}>Balance within Bounce</label>
        {params.balanceWithinBounce.enabled && (
          <input
            style={styles.input}
            placeholder="Enter balance"
            value={params.balanceWithinBounce.value}
            onChange={e => setValue('balanceWithinBounce', 'value', e.target.value)}
          />
        )}
      </div>
    </div>
  );
};

InspectionParameters.defaultProps = {
  onChanges: () => {},
  data: null
};

InspectionParameters.propTypes = {
  onChanges: PropTypes.func,
  data: PropTypes.object
};

export default InspectionParameters;





